import type { FaireProductEntity } from "../../entity_types/product";

export const p_8q7vpbbst2: FaireProductEntity = {
  token: "p_8q7vpbbst2",
  type: "product",
  name: "Newborn Gift Set, Baby Shower Gift Basket",
  brandToken: "b_thbeyjag8q",
  brandName: "Baby Bliss",
  imageUrl:
    "https://cdn.faire.com/fastly/241f8a21c1aaf9d46c1acfd509017485d3a578773524941c275754e8b4e0b9ea.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/540dbd51fe4738812126291c1088ff1bb1c1a245ae8851bdd6ed1ff13ed94499.jpeg",
    "https://cdn.faire.com/fastly/5680717e7f2a9c8b1fc387bd080cd6e9f4ea0dcfb994274d97c32a3d33ac5b77.jpeg",
    "https://cdn.faire.com/fastly/90642ed2e358b80e3309998be5746de61143ab0a3ad86272a46bd9300f0758b1.jpeg",
    "https://cdn.faire.com/fastly/cf406578ad4751d7eda0b870414c148521f3fda3ea35f98cf8ce2e652a264e3f.jpeg",
    "https://cdn.faire.com/fastly/b9f50178b587847b1aa58dee631de54a028b2e8016adf9aa91a6004eb0c3398b.jpeg",
    "https://cdn.faire.com/fastly/f651cfa6e799633f3009ce7667e5c950366499a7ef5e0959d1b9fd5208e81a4b.jpeg",
    "https://cdn.faire.com/fastly/45d60ced5242736a3fd71f63882095ff831abc96b437e63a1701509979ab9ca4.jpeg",
    "https://cdn.faire.com/fastly/4ea4db076f313bfc77b9ea7bbff2fd6bfcf6804b002721af5f153db40d94ab89.jpeg",
    "https://cdn.faire.com/fastly/e82cea8f65ac542f7b34c164784940e7c54fa4178e9d13f6c2447d20aa02bebe.jpeg",
    "https://cdn.faire.com/fastly/0188e758577dce5dfd16d30fba7dcade0743441cba9dfb3f1417ffb05820f19e.jpeg",
  ],
  priceDollars: 27.99,
  description:
    "A thoughtful gift set filled with must-have newborn essentials, made to welcome your bundle of joy into the world. This baby shower gift set includes our best-selling pacifiers, finger toothbrushes, star pacifier case, teether straps, a bamboo muslin swaddle blanket, a wooden hairbrush, and a welcome baby sign. Perfect for welcoming a new baby, celebrating a baby shower, or gifting to expectant parents. Beautifully curated and designed in Canada.\n\nDetails:\n\n* 100% food-grade silicone and natural materials\n* BPA, PVC, BPS, Lead, and Phthalate free\n* Durable and gentle on newborn skin and gums\n* Gift set includes: 2 pacifiers, 2 finger toothbrushes, 1 star pacifier case, 2 teether straps, 1 bamboo muslin swaddle blanket, 1 wooden hairbrush, and 1 welcome baby sign\n* Beautifully packaged in a Baby Bliss gift box",
  tags: [],
  msrpDollars: 55.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:46.980Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
